import React, { useState } from "react";
import { Row, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import TableNoDataIndication from "../common/TableNoDataIndication";

const ManagePageList = ({ tblData, loading, setSelectedRow, setModal, setIsAddMode, deleteById, getData, handleChangeStatus }) => {

    const tblColumn = [{
        dataField: '',
        text: 'Sr.No.',
        formatter: (value, row, index) => {
            return (<>{index + 1}</>)
        }
    }, {
        dataField: 'pageTitle',
        text: 'Page Title',
        sort: true
    },
    // {
    //     dataField: 'pageDescription',
    //     text: 'Page Description',
    //     sort: false,
    //     formatter: (value, row) => {
    //         return(
    //             <div>{row.pageDescription}</div>
    //         )
    //     }
    // },
    {
        dataField: 'status',
        text: 'Status',
        // sort: false
        formatter: (value, row) => {
            return (
                <BootstrapSwitchButton
                    checked={row.status === 1 ? true : false}
                    onChange={(checked) => {
                        console.log('Checked ', checked)
                        handleChangeStatus(row._id, checked)
                    }}
                    offstyle="secondary"
                />
            )
        }
    }, {
        dataField: '',
        text: 'Action',
        formatter: (value, row) => {
            return (
                <>{row.pageType === 1 &&
                    <UncontrolledDropdown>
                        <DropdownToggle className="card-drop" tag="a">
                            <i className="lni lni-more-alt font-size-16" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end action_drop_down">
                            <DropdownItem onClick={() => {
                                setSelectedRow(row);
                                setIsAddMode('Edit');
                                setModal(true)
                            }}>
                                <i className="lni lni-pencil font-size-16 text-success me-1" />{" "}
                                Edit
                            </DropdownItem>
                            {/* <DropdownItem onClick={() => localStorage.setItem("isCustomerEdit", 1)}>
                            <i className="lni lni-eye font-size-16 text-primary me-1" />{" "}
                            View
                        </DropdownItem>
                        <DropdownItem onClick={() => localStorage.setItem("isCustomerEdit", 1)}>
                            <i className="bx bx-copy font-size-16 text-default me-1" />{" "}
                            Copy
                        </DropdownItem> */}
                            <DropdownItem onClick={() => {
                                // localStorage.setItem("isCustomerEdit", value);
                                deleteById(row._id);
                                getData();
                            }}>
                                <i className="lni lni-trash font-size-16 text-danger me-1" />{" "}
                                Delete
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                }
                </>
            );
        }
    }];


    const defaultSorted = [{
        dataField: '_id',
        order: 'asc'
    }];
    const pzipcodeOptions = {
        sizePerPzipcode: 10,
        totalSize: tblData.length, // replace later with size(customers),
        custom: true
    };
    return (

        <React.Fragment>
            <PaginationProvider
                pagination={paginationFactory(pzipcodeOptions)}
                keyField='id'
                columns={tblColumn}
                data={tblData}
            >
                {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                        keyField='_id'
                        columns={tblColumn}
                        data={tblData}
                    >
                        {toolkitProps => (
                            <React.Fragment>
                                <Row className="mb-2" style={{ display: 'none' }}>
                                    <Col md="4">
                                        <div className="search-box me-2 mb-2 d-inline-block">
                                            <div className="status-relative">
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl="12">
                                        <div className="table-responsive">
                                            <BootstrapTable
                                                noDataIndication={<TableNoDataIndication loading={loading} />}
                                                keyField={"id"}
                                                responsive
                                                bordered={false}
                                                striped={false}
                                                defaultSorted={defaultSorted}
                                                classes={
                                                    "table table-striped align-middle table-nowrap"
                                                }
                                                headerWrapperClasses={"thead-light"}
                                                {...toolkitProps.baseProps}
                                                {...paginationTableProps}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                {tblData.length > 0 &&
                                    <Row className="align-items-md-center mt-30">
                                        <Col className="inner-custom-pagination mt-2 d-flex">
                                            <div className="d-inline">
                                                <SizePerPageDropdownStandalone
                                                    {...paginationProps}
                                                />
                                            </div>
                                            <div className="text-md-right ms-auto">
                                                <PaginationListStandalone
                                                    {...paginationProps}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </React.Fragment>
                        )
                        }
                    </ToolkitProvider>
                )
                }</PaginationProvider>
        </React.Fragment>

    )
}

export default ManagePageList;
